/*
  Chargement differe reel des images situees sous le premier ecran.

  Pourquoi ce fichier existe. L'attribut loading="lazy" laisse au navigateur le soin de
  decider quand demander une image. Sur une connexion lente, Chrome elargit sa marge
  d'anticipation a environ trois mille pixels sous l'ecran visible et demande donc tout
  de suite les images des sections suivantes. Mesure faite sur la page d'accueil, huit
  cent soixante-quinze kilo-octets d'images partent avant celle du haut de page, qui
  n'en pese que quatre-vingt-dix-neuf, et son affichage tombe a huit secondes et demie.

  Le principe. Les sections concernees n'ecrivent pas l'adresse de l'image dans src mais
  dans data-src. Rien ne part au chargement. Ce script la recopie des que la SECTION
  approche, avec une marge de huit cents pixels.

  C'est la section qu'on surveille, pas chaque image, et c'est important. Plusieurs de
  ces sections sont des carrousels horizontaux dont les cartes sont decalees hors de
  l'ecran sur la droite. Une premiere version surveillait chaque image : celles des
  cartes non visibles lateralement n'entraient jamais dans l'ecran, ne recevaient jamais
  leur adresse, et restaient vides une fois le carrousel fait defiler. Seize images sur
  vingt-quatre etaient dans ce cas.

  Le repli compte autant que le mecanisme. Sans IntersectionObserver, ou si le script
  n'arrive jamais, les images doivent apparaitre quand meme : la balise noscript posee
  a cote par les sections s'en charge pour le second cas, et la pose immediate
  ci-dessous pour le premier.
*/
(function () {
  var MARGE = '800px';

  function poser(img) {
    /* Ces images sont toutes sous le premier ecran. Elles ne doivent jamais
       prendre la bande passante de la grande photo du haut, qui est ce que le
       visiteur regarde. On les declare donc en priorite basse au moment ou on
       leur pose leur adresse, c'est-a-dire avant que la demande ne parte.
       Mesure du 25/09/2026 : sans cela, les cinq photos des Meilleures ventes
       arrivaient AVANT la photo du haut et la retardaient d'une seconde. */
    if (!img.getAttribute('fetchpriority')) {
      img.setAttribute('fetchpriority', 'low');
    }
    if (img.dataset.srcset) {
      img.setAttribute('srcset', img.dataset.srcset);
      delete img.dataset.srcset;
    }
    if (img.dataset.src) {
      img.setAttribute('src', img.dataset.src);
      delete img.dataset.src;
    }
    img.classList.remove('yzavo-differe');
  }

  function poserTout(racine) {
    var images = racine.querySelectorAll('img.yzavo-differe[data-src]');
    Array.prototype.forEach.call(images, poser);
  }

  /* TOUTE la galerie est prete avant que le visiteur ne balaie.

     Constat du 25/09/2026, mesure sur la fiche housse : trois photos sur treize
     etaient pretes a 5,8 s, six a 9,1 s, et les treize seulement a 12,2 s. Les
     suivantes n'etaient demandees qu'au moment ou le doigt arrivait dessus, d'ou
     un blanc a chaque balayage. Dans la fenetre d'agrandissement c'etait pire :
     ses visuels sont en display:none, le navigateur ne les chargeait donc JAMAIS
     d'avance, zero sur treize meme apres vingt-trois secondes.

     On les reveille toutes des que la photo principale est affichee. Elle garde
     la priorite pour elle seule, et le reste part aussitot derriere, en priorite
     basse. La fenetre d'agrandissement demande exactement les memes adresses, elle
     les trouve donc en cache et s'affiche sans attendre. */
  function galerieEntiere() {
    var reste = document.querySelectorAll('.product__media-list img[loading="lazy"]');
    if (!reste.length) return;
    var principale = document.querySelector('.product__media-list img[fetchpriority="high"]');
    var fait = false;

    /* On les reveille PAR DEUX, dans l'ordre du carrousel, chaque paire quand la
       precedente est arrivee. Les reveiller toutes d'un coup partageait la bande
       passante entre douze photos : la deuxieme, celle qu'on voit au premier
       balayage, arrivait alors aussi tard que la derniere. En chaine, chacune
       arrive au moment ou le doigt peut l'atteindre. */
    function chaine(liste, i) {
      if (i >= liste.length) return;
      var lot = Array.prototype.slice.call(liste, i, i + 2);
      var restants = lot.length;
      var passe = false;
      function suite() {
        restants -= 1;
        if (restants > 0 || passe) return;
        passe = true;
        chaine(liste, i + 2);
      }
      lot.forEach(function (img) {
        img.addEventListener('load', suite);
        img.addEventListener('error', suite);
        if (!img.getAttribute('fetchpriority')) img.setAttribute('fetchpriority', 'low');
        img.setAttribute('loading', 'eager');
      });
      /* Une photo qui n'arrive pas ne doit pas bloquer la suite de la chaine. */
      window.setTimeout(function () { if (!passe) { passe = true; chaine(liste, i + 2); } }, 3000);
    }

    function reveiller() {
      if (fait) return;
      fait = true;
      chaine(reste, 0);
    }
    if (!principale || principale.complete) { reveiller(); return; }
    principale.addEventListener('load', reveiller);
    principale.addEventListener('error', reveiller);
    /* Filet de securite : une photo principale qui n'arrive jamais ne doit pas
       bloquer tout le reste de la galerie. */
    window.setTimeout(reveiller, 4000);
  }

  function demarrer() {
    galerieEntiere();
    var images = document.querySelectorAll('img.yzavo-differe[data-src]');
    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(images, poser);
      return;
    }

    // Une image appartient a une section ; on remonte jusqu'a elle pour surveiller
    // l'ensemble d'un seul tenant, carrousel compris.
    var sections = [];
    Array.prototype.forEach.call(images, function (img) {
      var s = img.closest('.shopify-section') || img.parentElement;
      if (s && sections.indexOf(s) === -1) sections.push(s);
    });

    var veilleur = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        poserTout(e.target);
        veilleur.unobserve(e.target);
      });
    }, { rootMargin: MARGE });

    sections.forEach(function (s) { veilleur.observe(s); });

    // Filet de securite. Si le visiteur ne fait jamais defiler la page, les images
    // restent vides, ce qui est voulu. Mais s'il imprime la page ou y cherche un mot,
    // il faut qu'elles soient la.
    window.addEventListener('beforeprint', function () { poserTout(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // Les sections rechargees par l'editeur de theme reintroduisent des images differees.
  document.addEventListener('shopify:section:load', demarrer);
})();